import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Products from './components/Products';
import ProductsPage from './components/ProductsPage';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

// removed: import Cart from './components/Cart';
import { CartProvider } from './components/CartContext';
import InstrumentDetailsPage from './components/InstrumentDetailsPage';
import Catalogue from './components/Catalogue';
import SurgicalSetsPage from './components/SurgicalSetsPage';
import SurgicalSetDetailsPage from './components/SurgicalSetDetailsPage';

// Scroll to top on route change
function ScrollToTop() {
  const location = useLocation();
  React.useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location.pathname, location.hash]);
  return null;
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <CartProvider>
        <div className="App">
          {isLoading && (
            <div className="loading-screen" aria-label="Loading">
              <div className="loading-content">
                <div className="loading-logo">
                  <img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="Purelife impex Logo" />
                  <h1>Purelife impex</h1>
                </div>
              </div>
            </div>
          )}
          <Header />
          <ScrollToTop />
          <main>
            <Routes>
              <Route path="/" element={
                <>
                  <Hero />
                  <Products />
                  {/* Re-added About to the home page per revert */}
                  <About />
                  <Contact />
                </>
              } />
              {/* Removed dedicated /about route per revert */}
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:id" element={<InstrumentDetailsPage />} />
              {/* Cart removed as requested */}
              <Route path="/catalogue" element={<Catalogue />} />
              <Route path="/surgical-sets" element={<SurgicalSetsPage />} />
              <Route path="/surgical-sets/:id" element={<SurgicalSetDetailsPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </CartProvider>
    </Router>
  );
}

export default App;